module.exports = __webpack_public_path__ + "media/feature-icons/mobile_payments-30ce34b9.png";